import { render, staticRenderFns } from "./AnnotationProfileProjectionTable.vue?vue&type=template&id=246ed2d4&scoped=true"
import script from "./AnnotationProfileProjectionTable.vue?vue&type=script&lang=js"
export * from "./AnnotationProfileProjectionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246ed2d4",
  null
  
)

export default component.exports